import { extractTimeStampLatLongValuesFromURL, extractEDRImageTimeStampValuesFromURL } from "./utils";
import { downloadBlobDataByURLs, FILE_TYPES } from "../../../../../common/ProImages/components/utils/blobUtils";

export const STOP_IMAGES = {
  signature: "Signature",
  physicaldr: "Physical DR",
  proofofdelivery: "Proof of Delivery",
  trailer: "Trailer",
};

export const PRO_IMAGES = {
  exception: "Exception",
  excessivelength: "Excessive Length",
  tallycount: "Tally Count",
  suffixpro: "Suffix Pro",
  canadapro: "Canada Pro",
  mexicopro: "Mexico Pro",
  puertoricopro: "Puerto Rico Pro",
  bol: "Bill Of Lading",
  hazmat: "Hazmat",
  edr: "EDR",
  proofofpickup: "Proof of Pickup",
  adn: "Advance Delivery Notification",
  proofofdelivery: "Proof of Delivery",
};

const getMappedImageDataWithTimestamp = (imageByImageName, type) => {
  return imageByImageName.map((url, index) => {
    const key =
      type === FILE_TYPES.PDF
        ? extractEDRImageTimeStampValuesFromURL(url).timestamp
        : extractTimeStampLatLongValuesFromURL(url).timestamp;
    return {
      key: key ?? index,
      url
    };
  });
};

export function getImagesFromBlobStorage({
  folderName,
  imageData,
  updateFunction,
  handleError,
  fileType,
}) {
  let populatedImageData = {};
  Promise.all(
    Object.keys(imageData).map((imageKeyName) => {
      const imagesDataByKey = getMappedImageDataWithTimestamp(
        imageData[imageKeyName],fileType
      );
      return downloadBlobDataByURLs(imagesDataByKey).then((images) => {
        images.forEach((image) => {
          populatedImageData = {
            ...populatedImageData,
            [imageKeyName]: [
              ...(populatedImageData[imageKeyName] ?? []),
              {
                key: image.key,
                blobData: `${fileType}${image.blobData}`,
              },
            ],
          };
        });
      });
    })
  )
    .then((_responses) => {
      updateFunction(folderName, populatedImageData);
    })
    .catch((error) => {
      handleError();
      console.log(error);
    });
}
